import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import {
  GameAssetDropDown,
  GameAssetTypeDescription,
  GameAssetTypeLabels,
  PremiumGameAssetDropDown,
} from "@seabrookstudios/pitch2table-core";
import CircularProgress from "@mui/material/CircularProgress";
import { useGameFiles, useMyEntitlements, useUpdateGameFile } from "@seabrookstudios/pitch2table";

const Label = "Asset Type";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").GameAssetType|undefined} props.value
 * @param {(value: import("@seabrookstudios/pitch2table-core").GameAssetType) => void} props.onChange
 * @param {boolean} [props.isPending]
 * @param {string} props.helperText
 * @param {boolean} [props.disabled]
 */
export const AssetTypeSelect = ({ value, onChange, helperText, disabled = false, isPending = false }) => {
  const { data: entitlements } = useMyEntitlements();
  /**
   * @param {*} ev
   */
  const onChangeHandler = (ev) => {
    onChange(ev.target.value);
  };

  const dropDownOptions = entitlements?.isMember ? PremiumGameAssetDropDown : GameAssetDropDown;

  return (
    <FormControl sx={{ width: "100%" }} margin="normal" disabled={disabled}>
      <InputLabel id="play-test-audience-label">{Label}</InputLabel>
      <Select
        labelId="play-test-audience-label"
        id="play-test-audience"
        value={value}
        onChange={onChangeHandler}
        placeholder={Label}
        label={Label}
        input={<OutlinedInput label={Label} />}
      >
        {isPending ? (
          <CircularProgress />
        ) : (
          dropDownOptions.map((type) => (
            <MenuItem key={type} value={type}>
              {GameAssetTypeLabels[type]} - {GameAssetTypeDescription[type]}
            </MenuItem>
          ))
        )}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {import("@seabrookstudios/pitch2table-core").AttachmentId} props.attachmentId
 */
export const AssetTypeSelectContained = ({ gameId, attachmentId }) => {
  const { data: files = [] } = useGameFiles(gameId);
  const updateFile = useUpdateGameFile(gameId, attachmentId);

  /**
   * @param {import("@seabrookstudios/pitch2table-core").GameAssetType} type
   */
  const onEditType = async (type) => {
    await updateFile.mutateAsync({ type, archived: undefined, deleted: undefined, name: undefined });
  };
  const doc = files.find((doc) => doc.id === attachmentId);

  if (!doc) {
    return <CircularProgress />;
  }

  return <AssetTypeSelect helperText="How the file is used" value={doc.type} onChange={onEditType} />;
};
